import React from 'react';

type ChevronRightProps = {
  height?: number;
  width?: number;
  fill?: string;
}

export const ChevronRight = ({ height = 11, width = 7, fill = "#196ECF" }: ChevronRightProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 7 12"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.310934 10.1586L4.43546 5.9932L0.310934 1.82775C-0.103645 1.40906 -0.103645 0.732711 0.310934 0.314019C0.725513 -0.104673 1.39522 -0.104673 1.8098 0.314019L6.68907 5.2417C7.10364 5.66039 7.10364 6.33674 6.68907 6.75543L1.8098 11.6831C1.39522 12.1018 0.725513 12.1018 0.310934 11.6831C-0.0930143 11.2644 -0.103645 10.5773 0.310934 10.1586Z"
        fill={fill}
      />
    </svg>
  );
};
